import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import Modal, { SimpleModalControls } from "../../../components/Modal";
import { Input } from "@chakra-ui/react";


interface AddSubCategoryProps extends SimpleModalControls {
    id: string,
    resetData: () => void
}

const AddSubCategoryModal = (props: AddSubCategoryProps) => {
    const { t } = useTranslation("translations");
    const [categoryName, setCategoryName] = useState<string>("");
    const [saving, setSaving] = useState<boolean>(false);
    const save = async () => {
      setSaving(true);
      
      try {
        await getAxiosInstance().post("/Categories/add_subcategory", {parentId: props.id, name: categoryName});
        
        setCategoryName('');
        
        toast.success(t("CATEGORY_CREATED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT});
        props.resetData();
        props.onClose();
      } catch (e) {
        toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT});
      } finally {
        setSaving(false);
      }
    }
    
    return (
      <Modal
        header={t("NEW_CATEGORY_MODAL")}
        isOpen={props.isOpen}
        onClose={props.onClose}
        secondaryActionName={t("Save")}
        secondaryActionEnabled={categoryName.length > 3}
        secondaryAction={() => save()}
        secondaryActionLoading={saving}
      >
        <Input
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder={t("NEW_CATEGORY_MODAL_INPUT_PLACE_HOLDER_TEXT")}
        />
      </Modal>
    )
}

export default AddSubCategoryModal;